import { Injectable } from '@angular/core';
import { RestService } from '../../../core/services/rest.service';
import { PaginationResult } from 'src/app/core/models/response/pagination-result.response';
import { toPaginatedResponse } from 'src/app/core/mappers/pagination.mapper';
import { toInboxModelCollection } from 'src/app/core/mappers/inbox.mapper';
import { Subject, Observable } from 'rxjs';
import { InboxModel } from 'src/app/core/models/inbox.model';

@Injectable()
export class InboxService {
  private readonly USER_MESSAGES_ENDPOINT: string = 'user/userMessages';
  private readonly MARK_AS_READED_ENDPOINT: string = 'user/updateMessage';

  private scrollToMessageSubject = new Subject<any>();

  constructor(private restService: RestService) {}

  public async getMessages(from: number, to: number): Promise<PaginationResult<InboxModel[]>> {
    try {
      let response = await this.restService.post(this.USER_MESSAGES_ENDPOINT, { desde: from, hasta: to });
      if (response.listOfResults.size > 0) {
        let paginated = toPaginatedResponse<InboxModel[]>(response.listOfResults);
        paginated.listOfResult = toInboxModelCollection(paginated.listOfResult);
        return Promise.resolve(paginated);
      }
      return Promise.resolve(null);
    } catch (error) {
      return Promise.reject(new Error(error.message));
    }
  }

  public async markMessageAsReadedById(id: number): Promise<boolean> {
    try {
      let response = await this.restService.post(this.MARK_AS_READED_ENDPOINT, { genericId: id });
      if (response.object) {
        return Promise.resolve(<boolean>response.object);
      }
      return Promise.resolve(false);
    } catch (error) {
      return Promise.reject(new Error(error.message));
    }
  }

  scrollToMessage() {
    this.scrollToMessageSubject.next('');
  }

  getScrollToMessage(): Observable<any> {
    return this.scrollToMessageSubject.asObservable();
  }
}
